require('slick-carousel');

$(document).ready(() => {

    $('.js-product-gallery').slick({
        dots: false,
        lazyLoad: 'ondemand',
        arrows: false,
        speed: 1000,
        pauseOnFocus: true,
        slidesToShow: 4,
        autoplay: false,
        variableWidth: true,
        prevArrow: $('.gnav__prev'),
        nextArrow: $(this).closest('.block--gallery').find('.gnav__next'),
        // mobileFirst: true,
        responsive: [

            // {
            //   breakpoint: 768,
            //   settings: {
            //     centerMode: true
            //   }
            // }

            // {
            //   breakpoint: 768,
            //   settings: {
            //     dots: false,
            //     lazyLoad: 'ondemand',
            //     arrows: false,
            //     speed: 1000,
            //     pauseOnFocus: true,
            //     slidesToShow: 1,
            //     autoplay: false,
            //     variableWidth: false,
            //     prevArrow: $('.gnav__prev'),
            //     nextArrow: $(this).closest('.block--gallery').find('.gnav__next'),
            //   }
            // }

        ]
    });

    $('.gnav__prev').on('click', () => {

        $('.js-product-gallery').slick('slickPrev');

    });

    $('.gnav__next').on('click', () => {

        $('.js-product-gallery').slick('slickNext');

    });

    // $('.js-product-gallery-tab').slick({
    //     dots: false,
    //     lazyLoad: 'ondemand',
    //     arrows: false,
    //     pauseOnFocus: true,
    //     slidesToShow: 1,
    //     autoplay: false,
    //     variableWidth: false,
    //     speed: 500,
    //     fade: true,
    //     cssEase: 'linear',
    //     prevArrow: $('.gnav__prevtab'),
    //     nextArrow: $(this).closest('.block--gallery').find('.gnav__nexttab'),
    //     responsive: []
    // });

    // $('.gnav__prevtab').on('click', () => {

    //     $('.js-product-gallery-tab').slick('slickPrev');

    // });

    // $('.gnav__nexttab').on('click', () => {

    //     $('.js-product-gallery-tab').slick('slickNext');

    // });

    $('[data-component="gallery"]').slick({
        dots: false,
        lazyLoad: 'ondemand',
        arrows: false,
        speed: 1000,
        pauseOnFocus: true,
        slidesToShow: 1,
        autoplay: false,
        arrows: true,
        // prevArrow: $('.gnav__prev'),
        // nextArrow: $(this).closest('.block--gallery').find('.gnav__next'),
        responsive: []
    });

    $('[data-component="gallery-tab"]').slick({
        dots: false,
        lazyLoad: 'ondemand',
        arrows: false,
        speed: 1000,
        pauseOnFocus: true,
        slidesToShow: 1,
        autoplay: false,
        arrows: true,
        // prevArrow: $('.gnav__prev'),
        // nextArrow: $(this).closest('.block--gallery').find('.gnav__next'),
        responsive: []
    });

    $('.js-slick-brandline').slick({
        dots: false,
        lazyLoad: 'ondemand',
        arrows: false,
        speed: 1000,
        pauseOnFocus: true,
        slidesToScroll: 5,
        slidesToShow: 5,
        autoplay: 5000,
        infinite: true,
        responsive: [

            {
              breakpoint: 991,
              settings: {
                slidesToScroll: 3,
                slidesToShow: 3
              }
            },

            {
              breakpoint: 620,
              settings: {
                slidesToScroll: 2,
                slidesToShow: 2
              }
            }
        ]
    });

});
